export enum ToolType {
  Polyline='polyline',
  Model='fixed-figure',
  Polygon='polygon',
  Rectangle='rectangle',
  Circle='circle'
}
